export default "__VITE_ASSET__DXPoYDXw__"